/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../global-client';
import type { RequestConfig, ResponseErrorConfig } from '../../global-client';
import type {
  DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
  DeleteApiChannelsDevicesDeviceIdPathParamsSchema,
  DeleteApiChannelsDevicesDeviceId401Schema,
} from '../types/deleteApiChannelsDevicesDeviceIdSchema';
import type {
  DeleteApiLogoutMutationResponseSchema,
  DeleteApiLogout401Schema,
  DeleteApiLogout422Schema,
} from '../types/deleteApiLogoutSchema';
import type {
  DeleteApiOauthAuthorizedApplicationsApplicationIdMutationResponseSchema,
  DeleteApiOauthAuthorizedApplicationsApplicationIdPathParamsSchema,
  DeleteApiOauthAuthorizedApplicationsApplicationId400Schema,
  DeleteApiOauthAuthorizedApplicationsApplicationId401Schema,
} from '../types/deleteApiOauthAuthorizedApplicationsApplicationIdSchema';
import type {
  DeleteApiOauthAuthorizedApplicationsMutationResponseSchema,
  DeleteApiOauthAuthorizedApplications400Schema,
  DeleteApiOauthAuthorizedApplications401Schema,
} from '../types/deleteApiOauthAuthorizedApplicationsSchema';
import type {
  DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
  DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema,
  DeleteApiPushSubscriptionsPushSubscriptionId401Schema,
  DeleteApiPushSubscriptionsPushSubscriptionId404Schema,
} from '../types/deleteApiPushSubscriptionsPushSubscriptionIdSchema';
import type {
  DeleteOauthAuthorizeMutationResponseSchema,
  DeleteOauthAuthorizeQueryParamsSchema,
  DeleteOauthAuthorize400Schema,
  DeleteOauthAuthorize401Schema,
} from '../types/deleteOauthAuthorizeSchema';
import type {
  GetApiAgreementsLatestEuaQueryResponseSchema,
  GetApiAgreementsLatestEua404Schema,
} from '../types/getApiAgreementsLatestEuaSchema';
import type { GetApiConfigChannelsAppVersionQueryResponseSchema } from '../types/getApiConfigChannelsAppVersionSchema';
import type { GetApiConfigRegionsQueryResponseSchema } from '../types/getApiConfigRegionsSchema';
import type {
  GetApiEmailPreferencesQueryResponseSchema,
  GetApiEmailPreferences401Schema,
} from '../types/getApiEmailPreferencesSchema';
import type {
  GetApiFeatureFlagsQueryResponseSchema,
  GetApiFeatureFlagsQueryParamsSchema,
  GetApiFeatureFlags422Schema,
} from '../types/getApiFeatureFlagsSchema';
import type {
  GetApiKnowledgeBaseArticlesQueryResponseSchema,
  GetApiKnowledgeBaseArticlesQueryParamsSchema,
  GetApiKnowledgeBaseArticles422Schema,
  GetApiKnowledgeBaseArticles503Schema,
} from '../types/getApiKnowledgeBaseArticlesSchema';
import type {
  GetApiKnowledgeBaseCategoriesQueryResponseSchema,
  GetApiKnowledgeBaseCategories422Schema,
  GetApiKnowledgeBaseCategories503Schema,
} from '../types/getApiKnowledgeBaseCategoriesSchema';
import type {
  GetApiOauthAuthorizedApplicationsQueryResponseSchema,
  GetApiOauthAuthorizedApplications400Schema,
  GetApiOauthAuthorizedApplications401Schema,
} from '../types/getApiOauthAuthorizedApplicationsSchema';
import type {
  GetApiOnboardingQueryResponseSchema,
  GetApiOnboarding401Schema,
  GetApiOnboarding404Schema,
} from '../types/getApiOnboardingSchema';
import type {
  GetApiProductToursProductTourKeyQueryResponseSchema,
  GetApiProductToursProductTourKeyPathParamsSchema,
  GetApiProductToursProductTourKey401Schema,
  GetApiProductToursProductTourKey404Schema,
} from '../types/getApiProductToursProductTourKeySchema';
import type {
  GetApiProjectsProjectIdQueryResponseSchema,
  GetApiProjectsProjectIdPathParamsSchema,
  GetApiProjectsProjectId404Schema,
} from '../types/getApiProjectsProjectIdSchema';
import type { GetApiSessionsQueryResponseSchema, GetApiSessions401Schema } from '../types/getApiSessionsSchema';
import type { GetApiTimeZonesQueryResponseSchema, GetApiTimeZones401Schema } from '../types/getApiTimeZonesSchema';
import type { GetApiUsersMeQueryResponseSchema, GetApiUsersMe401Schema } from '../types/getApiUsersMeSchema';
import type {
  GetOauthAuthorizeQueryResponseSchema,
  GetOauthAuthorizeQueryParamsSchema,
  GetOauthAuthorize400Schema,
  GetOauthAuthorize401Schema,
} from '../types/getOauthAuthorizeSchema';
import type {
  PatchApiEmailPreferencesMutationRequestSchema,
  PatchApiEmailPreferencesMutationResponseSchema,
  PatchApiEmailPreferences401Schema,
  PatchApiEmailPreferences422Schema,
} from '../types/patchApiEmailPreferencesSchema';
import type {
  PatchApiOnboardingMutationRequestSchema,
  PatchApiOnboardingMutationResponseSchema,
  PatchApiOnboarding401Schema,
  PatchApiOnboarding404Schema,
} from '../types/patchApiOnboardingSchema';
import type {
  PatchApiProductToursProductTourKeyMutationRequestSchema,
  PatchApiProductToursProductTourKeyMutationResponseSchema,
  PatchApiProductToursProductTourKeyPathParamsSchema,
  PatchApiProductToursProductTourKey401Schema,
  PatchApiProductToursProductTourKey404Schema,
} from '../types/patchApiProductToursProductTourKeySchema';
import type {
  PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema,
  PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
  PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema,
  PatchApiPushSubscriptionsPushSubscriptionId401Schema,
  PatchApiPushSubscriptionsPushSubscriptionId404Schema,
} from '../types/patchApiPushSubscriptionsPushSubscriptionIdSchema';
import type {
  PatchApiUsersMeMutationRequestSchema,
  PatchApiUsersMeMutationResponseSchema,
  PatchApiUsersMe401Schema,
  PatchApiUsersMe422Schema,
} from '../types/patchApiUsersMeSchema';
import type {
  PatchApiUsersPasswordMutationRequestSchema,
  PatchApiUsersPasswordMutationResponseSchema,
  PatchApiUsersPassword400Schema,
  PatchApiUsersPassword422Schema,
} from '../types/patchApiUsersPasswordSchema';
import type {
  PostApiAgreementsAcceptEuaMutationResponseSchema,
  PostApiAgreementsAcceptEuaQueryParamsSchema,
  PostApiAgreementsAcceptEua400Schema,
  PostApiAgreementsAcceptEua401Schema,
} from '../types/postApiAgreementsAcceptEuaSchema';
import type {
  PostApiAnalyticalEventsMutationRequestSchema,
  PostApiAnalyticalEventsMutationResponseSchema,
  PostApiAnalyticalEventsHeaderParamsSchema,
  PostApiAnalyticalEvents400Schema,
  PostApiAnalyticalEvents401Schema,
} from '../types/postApiAnalyticalEventsSchema';
import type {
  PostApiAuthenticationMutationRequestSchema,
  PostApiAuthenticationMutationResponseSchema,
  PostApiAuthentication400Schema,
} from '../types/postApiAuthenticationSchema';
import type {
  PostApiChannelsDevicesMutationRequestSchema,
  PostApiChannelsDevicesMutationResponseSchema,
  PostApiChannelsDevices400Schema,
  PostApiChannelsDevices401Schema,
  PostApiChannelsDevices422Schema,
} from '../types/postApiChannelsDevicesSchema';
import type {
  PostApiDirectUploadsUserAvatarMutationRequestSchema,
  PostApiDirectUploadsUserAvatarMutationResponseSchema,
  PostApiDirectUploadsUserAvatar400Schema,
  PostApiDirectUploadsUserAvatar401Schema,
} from '../types/postApiDirectUploadsUserAvatarSchema';
import type {
  PostApiFeedbacksMutationRequestSchema,
  PostApiFeedbacksMutationResponseSchema,
  PostApiFeedbacks401Schema,
  PostApiFeedbacks422Schema,
} from '../types/postApiFeedbacksSchema';
import type {
  PostApiLoginRefreshMutationResponseSchema,
  PostApiLoginRefreshHeaderParamsSchema,
  PostApiLoginRefresh400Schema,
  PostApiLoginRefresh401Schema,
} from '../types/postApiLoginRefreshSchema';
import type {
  PostApiLoginMutationRequestSchema,
  PostApiLoginMutationResponseSchema,
  PostApiLogin400Schema,
  PostApiLogin401Schema,
  PostApiLogin422Schema,
} from '../types/postApiLoginSchema';
import type {
  PostApiOnboardingFinishMutationRequestSchema,
  PostApiOnboardingFinishMutationResponseSchema,
  PostApiOnboardingFinish401Schema,
  PostApiOnboardingFinish404Schema,
  PostApiOnboardingFinish422Schema,
} from '../types/postApiOnboardingFinishSchema';
import type {
  PostApiProjectsProjectIdDefaultMutationResponseSchema,
  PostApiProjectsProjectIdDefaultPathParamsSchema,
  PostApiProjectsProjectIdDefault401Schema,
} from '../types/postApiProjectsProjectIdDefaultSchema';
import type {
  PostApiPushSubscriptionsMutationRequestSchema,
  PostApiPushSubscriptionsMutationResponseSchema,
  PostApiPushSubscriptions401Schema,
  PostApiPushSubscriptions422Schema,
} from '../types/postApiPushSubscriptionsSchema';
import type {
  PostApiServiceTokensMutationResponseSchema,
  PostApiServiceTokensHeaderParamsSchema,
  PostApiServiceTokens400Schema,
  PostApiServiceTokens401Schema,
} from '../types/postApiServiceTokensSchema';
import type {
  PostApiUsersConfirmationInstructionsMutationRequestSchema,
  PostApiUsersConfirmationInstructionsMutationResponseSchema,
} from '../types/postApiUsersConfirmationInstructionsSchema';
import type {
  PostApiUsersConfirmationMutationRequestSchema,
  PostApiUsersConfirmationMutationResponseSchema,
  PostApiUsersConfirmation400Schema,
  PostApiUsersConfirmation422Schema,
} from '../types/postApiUsersConfirmationSchema';
import type {
  PostApiUsersPasswordInstructionsMutationRequestSchema,
  PostApiUsersPasswordInstructionsMutationResponseSchema,
} from '../types/postApiUsersPasswordInstructionsSchema';
import type {
  PostApiUsersMutationRequestSchema,
  PostApiUsersMutationResponseSchema,
  PostApiUsers422Schema,
} from '../types/postApiUsersSchema';
import type {
  PostApiUsersUnlockInstructionsMutationRequestSchema,
  PostApiUsersUnlockInstructionsMutationResponseSchema,
} from '../types/postApiUsersUnlockInstructionsSchema';
import type {
  PostOauthAuthorizeMutationRequestSchema,
  PostOauthAuthorizeMutationResponseSchema,
  PostOauthAuthorize400Schema,
  PostOauthAuthorize401Schema,
} from '../types/postOauthAuthorizeSchema';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import {
  getApiAgreementsLatestEua,
  getApiConfigChannelsAppVersion,
  getApiConfigRegions,
  getApiEmailPreferences,
  getApiFeatureFlags,
  getApiKnowledgeBaseArticles,
  getApiKnowledgeBaseCategories,
  getOauthAuthorize,
  getApiOauthAuthorizedApplications,
  getApiOnboarding,
  getApiProductToursProductTourKey,
  getApiProjectsProjectId,
  getApiSessions,
  getApiTimeZones,
  getApiUsersMe,
  postApiAgreementsAcceptEua,
  postApiAnalyticalEvents,
  postApiLogin,
  deleteApiLogout,
  postApiAuthentication,
  postApiChannelsDevices,
  deleteApiChannelsDevicesDeviceId,
  postApiDirectUploadsUserAvatar,
  patchApiEmailPreferences,
  postApiFeedbacks,
  postOauthAuthorize,
  deleteOauthAuthorize,
  deleteApiOauthAuthorizedApplications,
  deleteApiOauthAuthorizedApplicationsApplicationId,
  patchApiOnboarding,
  postApiOnboardingFinish,
  patchApiProductToursProductTourKey,
  postApiProjectsProjectIdDefault,
  postApiPushSubscriptions,
  patchApiPushSubscriptionsPushSubscriptionId,
  deleteApiPushSubscriptionsPushSubscriptionId,
  postApiServiceTokens,
  postApiLoginRefresh,
  postApiUsersConfirmationInstructions,
  postApiUsersConfirmation,
  postApiUsers,
  patchApiUsersMe,
  postApiUsersPasswordInstructions,
  patchApiUsersPassword,
  postApiUsersUnlockInstructions,
} from '../api/index';
import { queryOptions, useQuery, useSuspenseQuery, mutationOptions, useMutation } from '@tanstack/react-query';

export const getApiAgreementsLatestEuaQueryKey = () => ['global', { url: '/api/agreements/latest_eua' }] as const;

export type GetApiAgreementsLatestEuaQueryKey = ReturnType<typeof getApiAgreementsLatestEuaQueryKey>;

export function getApiAgreementsLatestEuaQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiAgreementsLatestEuaQueryKey();
  return queryOptions<
    GetApiAgreementsLatestEuaQueryResponseSchema,
    ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>,
    GetApiAgreementsLatestEuaQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiAgreementsLatestEua(config);
    },
  });
}

/**
 * @summary Retrieves the latest End User Agreement
 * {@link /api/agreements/latest_eua}
 */
export function useGetApiAgreementsLatestEua<
  TData = GetApiAgreementsLatestEuaQueryResponseSchema,
  TQueryData = GetApiAgreementsLatestEuaQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiAgreementsLatestEuaQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiAgreementsLatestEuaQueryResponseSchema,
        ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiAgreementsLatestEuaQueryKey();

  const query = useQuery(
    {
      ...getApiAgreementsLatestEuaQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConfigChannelsAppVersionQueryKey = () =>
  ['global', { url: '/api/config/channels_app_version' }] as const;

export type GetApiConfigChannelsAppVersionQueryKey = ReturnType<typeof getApiConfigChannelsAppVersionQueryKey>;

export function getApiConfigChannelsAppVersionQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiConfigChannelsAppVersionQueryKey();
  return queryOptions<
    GetApiConfigChannelsAppVersionQueryResponseSchema,
    ResponseErrorConfig<Error>,
    GetApiConfigChannelsAppVersionQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConfigChannelsAppVersion(config);
    },
  });
}

/**
 * @summary Return the current channels app minimum version
 * {@link /api/config/channels_app_version}
 */
export function useGetApiConfigChannelsAppVersion<
  TData = GetApiConfigChannelsAppVersionQueryResponseSchema,
  TQueryData = GetApiConfigChannelsAppVersionQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConfigChannelsAppVersionQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiConfigChannelsAppVersionQueryResponseSchema,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiConfigChannelsAppVersionQueryKey();

  const query = useQuery(
    {
      ...getApiConfigChannelsAppVersionQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConfigRegionsQueryKey = () => ['global', { url: '/api/config/regions' }] as const;

export type GetApiConfigRegionsQueryKey = ReturnType<typeof getApiConfigRegionsQueryKey>;

export function getApiConfigRegionsQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiConfigRegionsQueryKey();
  return queryOptions<
    GetApiConfigRegionsQueryResponseSchema,
    ResponseErrorConfig<Error>,
    GetApiConfigRegionsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConfigRegions(config);
    },
  });
}

/**
 * @summary List all API regions and their URLs
 * {@link /api/config/regions}
 */
export function useGetApiConfigRegions<
  TData = GetApiConfigRegionsQueryResponseSchema,
  TQueryData = GetApiConfigRegionsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConfigRegionsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiConfigRegionsQueryResponseSchema,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiConfigRegionsQueryKey();

  const query = useQuery(
    {
      ...getApiConfigRegionsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiEmailPreferencesQueryKey = () => ['global', { url: '/api/email_preferences' }] as const;

export type GetApiEmailPreferencesQueryKey = ReturnType<typeof getApiEmailPreferencesQueryKey>;

export function getApiEmailPreferencesQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiEmailPreferencesQueryKey();
  return queryOptions<
    GetApiEmailPreferencesQueryResponseSchema,
    ResponseErrorConfig<GetApiEmailPreferences401Schema>,
    GetApiEmailPreferencesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiEmailPreferences(config);
    },
  });
}

/**
 * @summary Retrieves current user's email preferences
 * {@link /api/email_preferences}
 */
export function useGetApiEmailPreferences<
  TData = GetApiEmailPreferencesQueryResponseSchema,
  TQueryData = GetApiEmailPreferencesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiEmailPreferencesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiEmailPreferencesQueryResponseSchema,
        ResponseErrorConfig<GetApiEmailPreferences401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiEmailPreferencesQueryKey();

  const query = useQuery(
    {
      ...getApiEmailPreferencesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiEmailPreferences401Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiFeatureFlagsQueryKey = (params: GetApiFeatureFlagsQueryParamsSchema = {}) =>
  ['global', { url: '/api/feature_flags' }, ...(params ? [params] : [])] as const;

export type GetApiFeatureFlagsQueryKey = ReturnType<typeof getApiFeatureFlagsQueryKey>;

export function getApiFeatureFlagsQueryOptions(
  params?: GetApiFeatureFlagsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiFeatureFlagsQueryKey(params);
  return queryOptions<
    GetApiFeatureFlagsQueryResponseSchema,
    ResponseErrorConfig<GetApiFeatureFlags422Schema>,
    GetApiFeatureFlagsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiFeatureFlags(params, config);
    },
  });
}

/**
 * @summary Retrieves the list of feature flags
 * {@link /api/feature_flags}
 */
export function useGetApiFeatureFlags<
  TData = GetApiFeatureFlagsQueryResponseSchema,
  TQueryData = GetApiFeatureFlagsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiFeatureFlagsQueryKey,
>(
  params?: GetApiFeatureFlagsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiFeatureFlagsQueryResponseSchema,
        ResponseErrorConfig<GetApiFeatureFlags422Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiFeatureFlagsQueryKey(params);

  const query = useQuery(
    {
      ...getApiFeatureFlagsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiFeatureFlags422Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiKnowledgeBaseArticlesQueryKey = (params: GetApiKnowledgeBaseArticlesQueryParamsSchema) =>
  ['global', { url: '/api/knowledge_base/articles' }, ...(params ? [params] : [])] as const;

export type GetApiKnowledgeBaseArticlesQueryKey = ReturnType<typeof getApiKnowledgeBaseArticlesQueryKey>;

export function getApiKnowledgeBaseArticlesQueryOptions(
  params: GetApiKnowledgeBaseArticlesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiKnowledgeBaseArticlesQueryKey(params);
  return queryOptions<
    GetApiKnowledgeBaseArticlesQueryResponseSchema,
    ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>,
    GetApiKnowledgeBaseArticlesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiKnowledgeBaseArticles(params, config);
    },
  });
}

/**
 * @summary Retrieves knowledge base articles by tag
 * {@link /api/knowledge_base/articles}
 */
export function useGetApiKnowledgeBaseArticles<
  TData = GetApiKnowledgeBaseArticlesQueryResponseSchema,
  TQueryData = GetApiKnowledgeBaseArticlesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiKnowledgeBaseArticlesQueryKey,
>(
  params: GetApiKnowledgeBaseArticlesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiKnowledgeBaseArticlesQueryResponseSchema,
        ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiKnowledgeBaseArticlesQueryKey(params);

  const query = useQuery(
    {
      ...getApiKnowledgeBaseArticlesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiKnowledgeBaseCategoriesQueryKey = () =>
  ['global', { url: '/api/knowledge_base/categories' }] as const;

export type GetApiKnowledgeBaseCategoriesQueryKey = ReturnType<typeof getApiKnowledgeBaseCategoriesQueryKey>;

export function getApiKnowledgeBaseCategoriesQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiKnowledgeBaseCategoriesQueryKey();
  return queryOptions<
    GetApiKnowledgeBaseCategoriesQueryResponseSchema,
    ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>,
    GetApiKnowledgeBaseCategoriesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiKnowledgeBaseCategories(config);
    },
  });
}

/**
 * @summary Retrieves knowledge base categories
 * {@link /api/knowledge_base/categories}
 */
export function useGetApiKnowledgeBaseCategories<
  TData = GetApiKnowledgeBaseCategoriesQueryResponseSchema,
  TQueryData = GetApiKnowledgeBaseCategoriesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiKnowledgeBaseCategoriesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiKnowledgeBaseCategoriesQueryResponseSchema,
        ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiKnowledgeBaseCategoriesQueryKey();

  const query = useQuery(
    {
      ...getApiKnowledgeBaseCategoriesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getOauthAuthorizeQueryKey = (params: GetOauthAuthorizeQueryParamsSchema = {}) =>
  ['global', { url: '/oauth/authorize' }, ...(params ? [params] : [])] as const;

export type GetOauthAuthorizeQueryKey = ReturnType<typeof getOauthAuthorizeQueryKey>;

export function getOauthAuthorizeQueryOptions(
  params?: GetOauthAuthorizeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getOauthAuthorizeQueryKey(params);
  return queryOptions<
    GetOauthAuthorizeQueryResponseSchema,
    ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>,
    GetOauthAuthorizeQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getOauthAuthorize(params, config);
    },
  });
}

/**
 * @description Starts the authorization code flow.Returns the pre-authorization payload so the client can render a consent screen (render your approval UI,then POST back). In some conditions, consent can be skipped and the authorization code issued straight away.
 * @summary Validate a forwarded authorization request
 * {@link /oauth/authorize}
 */
export function useGetOauthAuthorize<
  TData = GetOauthAuthorizeQueryResponseSchema,
  TQueryData = GetOauthAuthorizeQueryResponseSchema,
  TQueryKey extends QueryKey = GetOauthAuthorizeQueryKey,
>(
  params?: GetOauthAuthorizeQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetOauthAuthorizeQueryResponseSchema,
        ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getOauthAuthorizeQueryKey(params);

  const query = useQuery(
    {
      ...getOauthAuthorizeQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOauthAuthorizedApplicationsQueryKey = () =>
  ['global', { url: '/api/oauth/authorized_applications' }] as const;

export type GetApiOauthAuthorizedApplicationsQueryKey = ReturnType<typeof getApiOauthAuthorizedApplicationsQueryKey>;

export function getApiOauthAuthorizedApplicationsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiOauthAuthorizedApplicationsQueryKey();
  return queryOptions<
    GetApiOauthAuthorizedApplicationsQueryResponseSchema,
    ResponseErrorConfig<GetApiOauthAuthorizedApplications400Schema | GetApiOauthAuthorizedApplications401Schema>,
    GetApiOauthAuthorizedApplicationsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOauthAuthorizedApplications(config);
    },
  });
}

/**
 * @summary Lists the OAuth applications authorised by the current user
 * {@link /api/oauth/authorized_applications}
 */
export function useGetApiOauthAuthorizedApplications<
  TData = GetApiOauthAuthorizedApplicationsQueryResponseSchema,
  TQueryData = GetApiOauthAuthorizedApplicationsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOauthAuthorizedApplicationsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiOauthAuthorizedApplicationsQueryResponseSchema,
        ResponseErrorConfig<GetApiOauthAuthorizedApplications400Schema | GetApiOauthAuthorizedApplications401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOauthAuthorizedApplicationsQueryKey();

  const query = useQuery(
    {
      ...getApiOauthAuthorizedApplicationsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiOauthAuthorizedApplications400Schema | GetApiOauthAuthorizedApplications401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOnboardingQueryKey = () => ['global', { url: '/api/onboarding' }] as const;

export type GetApiOnboardingQueryKey = ReturnType<typeof getApiOnboardingQueryKey>;

export function getApiOnboardingQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiOnboardingQueryKey();
  return queryOptions<
    GetApiOnboardingQueryResponseSchema,
    ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>,
    GetApiOnboardingQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOnboarding(config);
    },
  });
}

/**
 * @summary Retrieve the current user onboarding data
 * {@link /api/onboarding}
 */
export function useGetApiOnboarding<
  TData = GetApiOnboardingQueryResponseSchema,
  TQueryData = GetApiOnboardingQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOnboardingQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiOnboardingQueryResponseSchema,
        ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOnboardingQueryKey();

  const query = useQuery(
    {
      ...getApiOnboardingQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProductToursProductTourKeyQueryKey = (
  productTourKey: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key']
) =>
  [
    'global',
    {
      url: '/api/product_tours/:product_tour_key',
      params: { productTourKey: productTourKey },
    },
  ] as const;

export type GetApiProductToursProductTourKeyQueryKey = ReturnType<typeof getApiProductToursProductTourKeyQueryKey>;

export function getApiProductToursProductTourKeyQueryOptions(
  productTourKey: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiProductToursProductTourKeyQueryKey(productTourKey);
  return queryOptions<
    GetApiProductToursProductTourKeyQueryResponseSchema,
    ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>,
    GetApiProductToursProductTourKeyQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!productTourKey,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProductToursProductTourKey(productTourKey, config);
    },
  });
}

/**
 * @summary Retrieves the product tour status for the user
 * {@link /api/product_tours/:product_tour_key}
 */
export function useGetApiProductToursProductTourKey<
  TData = GetApiProductToursProductTourKeyQueryResponseSchema,
  TQueryData = GetApiProductToursProductTourKeyQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProductToursProductTourKeyQueryKey,
>(
  productTourKey: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProductToursProductTourKeyQueryResponseSchema,
        ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProductToursProductTourKeyQueryKey(productTourKey);

  const query = useQuery(
    {
      ...getApiProductToursProductTourKeyQueryOptions(productTourKey, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdQueryKey = (projectId: GetApiProjectsProjectIdPathParamsSchema['project_id']) =>
  ['global', { url: '/api/projects/:project_id', params: { projectId: projectId } }] as const;

export type GetApiProjectsProjectIdQueryKey = ReturnType<typeof getApiProjectsProjectIdQueryKey>;

export function getApiProjectsProjectIdQueryOptions(
  projectId: GetApiProjectsProjectIdPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiProjectsProjectIdQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdQueryResponseSchema,
    ResponseErrorConfig<GetApiProjectsProjectId404Schema>,
    GetApiProjectsProjectIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectId(projectId, config);
    },
  });
}

/**
 * @summary Retrieves a project
 * {@link /api/projects/:project_id}
 */
export function useGetApiProjectsProjectId<
  TData = GetApiProjectsProjectIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdPathParamsSchema['project_id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdQueryResponseSchema,
        ResponseErrorConfig<GetApiProjectsProjectId404Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProjectsProjectIdQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiProjectsProjectId404Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiSessionsQueryKey = () => ['global', { url: '/api/sessions' }] as const;

export type GetApiSessionsQueryKey = ReturnType<typeof getApiSessionsQueryKey>;

export function getApiSessionsQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiSessionsQueryKey();
  return queryOptions<
    GetApiSessionsQueryResponseSchema,
    ResponseErrorConfig<GetApiSessions401Schema>,
    GetApiSessionsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiSessions(config);
    },
  });
}

/**
 * @summary Retrieves current user's active sessions
 * {@link /api/sessions}
 */
export function useGetApiSessions<
  TData = GetApiSessionsQueryResponseSchema,
  TQueryData = GetApiSessionsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiSessionsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiSessionsQueryResponseSchema,
        ResponseErrorConfig<GetApiSessions401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiSessionsQueryKey();

  const query = useQuery(
    {
      ...getApiSessionsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiSessions401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiTimeZonesQueryKey = () => ['global', { url: '/api/time_zones' }] as const;

export type GetApiTimeZonesQueryKey = ReturnType<typeof getApiTimeZonesQueryKey>;

export function getApiTimeZonesQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiTimeZonesQueryKey();
  return queryOptions<
    GetApiTimeZonesQueryResponseSchema,
    ResponseErrorConfig<GetApiTimeZones401Schema>,
    GetApiTimeZonesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiTimeZones(config);
    },
  });
}

/**
 * @summary Retrieves time zones
 * {@link /api/time_zones}
 */
export function useGetApiTimeZones<
  TData = GetApiTimeZonesQueryResponseSchema,
  TQueryData = GetApiTimeZonesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiTimeZonesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiTimeZonesQueryResponseSchema,
        ResponseErrorConfig<GetApiTimeZones401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiTimeZonesQueryKey();

  const query = useQuery(
    {
      ...getApiTimeZonesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiTimeZones401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiUsersMeQueryKey = () => ['global', { url: '/api/users/me' }] as const;

export type GetApiUsersMeQueryKey = ReturnType<typeof getApiUsersMeQueryKey>;

export function getApiUsersMeQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiUsersMeQueryKey();
  return queryOptions<
    GetApiUsersMeQueryResponseSchema,
    ResponseErrorConfig<GetApiUsersMe401Schema>,
    GetApiUsersMeQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiUsersMe(config);
    },
  });
}

/**
 * @summary Retrieves current user
 * {@link /api/users/me}
 */
export function useGetApiUsersMe<
  TData = GetApiUsersMeQueryResponseSchema,
  TQueryData = GetApiUsersMeQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiUsersMeQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiUsersMeQueryResponseSchema,
        ResponseErrorConfig<GetApiUsersMe401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiUsersMeQueryKey();

  const query = useQuery(
    {
      ...getApiUsersMeQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiUsersMe401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiAgreementsLatestEuaSuspenseQueryKey = () =>
  ['global', { url: '/api/agreements/latest_eua' }] as const;

export type GetApiAgreementsLatestEuaSuspenseQueryKey = ReturnType<typeof getApiAgreementsLatestEuaSuspenseQueryKey>;

export function getApiAgreementsLatestEuaSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiAgreementsLatestEuaSuspenseQueryKey();
  return queryOptions<
    GetApiAgreementsLatestEuaQueryResponseSchema,
    ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>,
    GetApiAgreementsLatestEuaQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiAgreementsLatestEua(config);
    },
  });
}

/**
 * @summary Retrieves the latest End User Agreement
 * {@link /api/agreements/latest_eua}
 */
export function useGetApiAgreementsLatestEuaSuspense<
  TData = GetApiAgreementsLatestEuaQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiAgreementsLatestEuaSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiAgreementsLatestEuaQueryResponseSchema,
        ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiAgreementsLatestEuaSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiAgreementsLatestEuaSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConfigChannelsAppVersionSuspenseQueryKey = () =>
  ['global', { url: '/api/config/channels_app_version' }] as const;

export type GetApiConfigChannelsAppVersionSuspenseQueryKey = ReturnType<
  typeof getApiConfigChannelsAppVersionSuspenseQueryKey
>;

export function getApiConfigChannelsAppVersionSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiConfigChannelsAppVersionSuspenseQueryKey();
  return queryOptions<
    GetApiConfigChannelsAppVersionQueryResponseSchema,
    ResponseErrorConfig<Error>,
    GetApiConfigChannelsAppVersionQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConfigChannelsAppVersion(config);
    },
  });
}

/**
 * @summary Return the current channels app minimum version
 * {@link /api/config/channels_app_version}
 */
export function useGetApiConfigChannelsAppVersionSuspense<
  TData = GetApiConfigChannelsAppVersionQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConfigChannelsAppVersionSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiConfigChannelsAppVersionQueryResponseSchema,
        ResponseErrorConfig<Error>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiConfigChannelsAppVersionSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiConfigChannelsAppVersionSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConfigRegionsSuspenseQueryKey = () => ['global', { url: '/api/config/regions' }] as const;

export type GetApiConfigRegionsSuspenseQueryKey = ReturnType<typeof getApiConfigRegionsSuspenseQueryKey>;

export function getApiConfigRegionsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiConfigRegionsSuspenseQueryKey();
  return queryOptions<
    GetApiConfigRegionsQueryResponseSchema,
    ResponseErrorConfig<Error>,
    GetApiConfigRegionsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConfigRegions(config);
    },
  });
}

/**
 * @summary List all API regions and their URLs
 * {@link /api/config/regions}
 */
export function useGetApiConfigRegionsSuspense<
  TData = GetApiConfigRegionsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConfigRegionsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<GetApiConfigRegionsQueryResponseSchema, ResponseErrorConfig<Error>, TData, TQueryKey>
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiConfigRegionsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiConfigRegionsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiEmailPreferencesSuspenseQueryKey = () => ['global', { url: '/api/email_preferences' }] as const;

export type GetApiEmailPreferencesSuspenseQueryKey = ReturnType<typeof getApiEmailPreferencesSuspenseQueryKey>;

export function getApiEmailPreferencesSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiEmailPreferencesSuspenseQueryKey();
  return queryOptions<
    GetApiEmailPreferencesQueryResponseSchema,
    ResponseErrorConfig<GetApiEmailPreferences401Schema>,
    GetApiEmailPreferencesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiEmailPreferences(config);
    },
  });
}

/**
 * @summary Retrieves current user's email preferences
 * {@link /api/email_preferences}
 */
export function useGetApiEmailPreferencesSuspense<
  TData = GetApiEmailPreferencesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiEmailPreferencesSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiEmailPreferencesQueryResponseSchema,
        ResponseErrorConfig<GetApiEmailPreferences401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiEmailPreferencesSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiEmailPreferencesSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiEmailPreferences401Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiFeatureFlagsSuspenseQueryKey = (params: GetApiFeatureFlagsQueryParamsSchema = {}) =>
  ['global', { url: '/api/feature_flags' }, ...(params ? [params] : [])] as const;

export type GetApiFeatureFlagsSuspenseQueryKey = ReturnType<typeof getApiFeatureFlagsSuspenseQueryKey>;

export function getApiFeatureFlagsSuspenseQueryOptions(
  params?: GetApiFeatureFlagsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiFeatureFlagsSuspenseQueryKey(params);
  return queryOptions<
    GetApiFeatureFlagsQueryResponseSchema,
    ResponseErrorConfig<GetApiFeatureFlags422Schema>,
    GetApiFeatureFlagsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiFeatureFlags(params, config);
    },
  });
}

/**
 * @summary Retrieves the list of feature flags
 * {@link /api/feature_flags}
 */
export function useGetApiFeatureFlagsSuspense<
  TData = GetApiFeatureFlagsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiFeatureFlagsSuspenseQueryKey,
>(
  params?: GetApiFeatureFlagsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiFeatureFlagsQueryResponseSchema,
        ResponseErrorConfig<GetApiFeatureFlags422Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiFeatureFlagsSuspenseQueryKey(params);

  const query = useSuspenseQuery(
    {
      ...getApiFeatureFlagsSuspenseQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiFeatureFlags422Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiKnowledgeBaseArticlesSuspenseQueryKey = (params: GetApiKnowledgeBaseArticlesQueryParamsSchema) =>
  ['global', { url: '/api/knowledge_base/articles' }, ...(params ? [params] : [])] as const;

export type GetApiKnowledgeBaseArticlesSuspenseQueryKey = ReturnType<
  typeof getApiKnowledgeBaseArticlesSuspenseQueryKey
>;

export function getApiKnowledgeBaseArticlesSuspenseQueryOptions(
  params: GetApiKnowledgeBaseArticlesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiKnowledgeBaseArticlesSuspenseQueryKey(params);
  return queryOptions<
    GetApiKnowledgeBaseArticlesQueryResponseSchema,
    ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>,
    GetApiKnowledgeBaseArticlesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiKnowledgeBaseArticles(params, config);
    },
  });
}

/**
 * @summary Retrieves knowledge base articles by tag
 * {@link /api/knowledge_base/articles}
 */
export function useGetApiKnowledgeBaseArticlesSuspense<
  TData = GetApiKnowledgeBaseArticlesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiKnowledgeBaseArticlesSuspenseQueryKey,
>(
  params: GetApiKnowledgeBaseArticlesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiKnowledgeBaseArticlesQueryResponseSchema,
        ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiKnowledgeBaseArticlesSuspenseQueryKey(params);

  const query = useSuspenseQuery(
    {
      ...getApiKnowledgeBaseArticlesSuspenseQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiKnowledgeBaseCategoriesSuspenseQueryKey = () =>
  ['global', { url: '/api/knowledge_base/categories' }] as const;

export type GetApiKnowledgeBaseCategoriesSuspenseQueryKey = ReturnType<
  typeof getApiKnowledgeBaseCategoriesSuspenseQueryKey
>;

export function getApiKnowledgeBaseCategoriesSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiKnowledgeBaseCategoriesSuspenseQueryKey();
  return queryOptions<
    GetApiKnowledgeBaseCategoriesQueryResponseSchema,
    ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>,
    GetApiKnowledgeBaseCategoriesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiKnowledgeBaseCategories(config);
    },
  });
}

/**
 * @summary Retrieves knowledge base categories
 * {@link /api/knowledge_base/categories}
 */
export function useGetApiKnowledgeBaseCategoriesSuspense<
  TData = GetApiKnowledgeBaseCategoriesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiKnowledgeBaseCategoriesSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiKnowledgeBaseCategoriesQueryResponseSchema,
        ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiKnowledgeBaseCategoriesSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiKnowledgeBaseCategoriesSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getOauthAuthorizeSuspenseQueryKey = (params: GetOauthAuthorizeQueryParamsSchema = {}) =>
  ['global', { url: '/oauth/authorize' }, ...(params ? [params] : [])] as const;

export type GetOauthAuthorizeSuspenseQueryKey = ReturnType<typeof getOauthAuthorizeSuspenseQueryKey>;

export function getOauthAuthorizeSuspenseQueryOptions(
  params?: GetOauthAuthorizeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getOauthAuthorizeSuspenseQueryKey(params);
  return queryOptions<
    GetOauthAuthorizeQueryResponseSchema,
    ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>,
    GetOauthAuthorizeQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getOauthAuthorize(params, config);
    },
  });
}

/**
 * @description Starts the authorization code flow.Returns the pre-authorization payload so the client can render a consent screen (render your approval UI,then POST back). In some conditions, consent can be skipped and the authorization code issued straight away.
 * @summary Validate a forwarded authorization request
 * {@link /oauth/authorize}
 */
export function useGetOauthAuthorizeSuspense<
  TData = GetOauthAuthorizeQueryResponseSchema,
  TQueryKey extends QueryKey = GetOauthAuthorizeSuspenseQueryKey,
>(
  params?: GetOauthAuthorizeQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetOauthAuthorizeQueryResponseSchema,
        ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getOauthAuthorizeSuspenseQueryKey(params);

  const query = useSuspenseQuery(
    {
      ...getOauthAuthorizeSuspenseQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOauthAuthorizedApplicationsSuspenseQueryKey = () =>
  ['global', { url: '/api/oauth/authorized_applications' }] as const;

export type GetApiOauthAuthorizedApplicationsSuspenseQueryKey = ReturnType<
  typeof getApiOauthAuthorizedApplicationsSuspenseQueryKey
>;

export function getApiOauthAuthorizedApplicationsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiOauthAuthorizedApplicationsSuspenseQueryKey();
  return queryOptions<
    GetApiOauthAuthorizedApplicationsQueryResponseSchema,
    ResponseErrorConfig<GetApiOauthAuthorizedApplications400Schema | GetApiOauthAuthorizedApplications401Schema>,
    GetApiOauthAuthorizedApplicationsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOauthAuthorizedApplications(config);
    },
  });
}

/**
 * @summary Lists the OAuth applications authorised by the current user
 * {@link /api/oauth/authorized_applications}
 */
export function useGetApiOauthAuthorizedApplicationsSuspense<
  TData = GetApiOauthAuthorizedApplicationsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOauthAuthorizedApplicationsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiOauthAuthorizedApplicationsQueryResponseSchema,
        ResponseErrorConfig<GetApiOauthAuthorizedApplications400Schema | GetApiOauthAuthorizedApplications401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOauthAuthorizedApplicationsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiOauthAuthorizedApplicationsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiOauthAuthorizedApplications400Schema | GetApiOauthAuthorizedApplications401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOnboardingSuspenseQueryKey = () => ['global', { url: '/api/onboarding' }] as const;

export type GetApiOnboardingSuspenseQueryKey = ReturnType<typeof getApiOnboardingSuspenseQueryKey>;

export function getApiOnboardingSuspenseQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiOnboardingSuspenseQueryKey();
  return queryOptions<
    GetApiOnboardingQueryResponseSchema,
    ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>,
    GetApiOnboardingQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOnboarding(config);
    },
  });
}

/**
 * @summary Retrieve the current user onboarding data
 * {@link /api/onboarding}
 */
export function useGetApiOnboardingSuspense<
  TData = GetApiOnboardingQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOnboardingSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiOnboardingQueryResponseSchema,
        ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOnboardingSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiOnboardingSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProductToursProductTourKeySuspenseQueryKey = (
  productTourKey: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key']
) =>
  [
    'global',
    {
      url: '/api/product_tours/:product_tour_key',
      params: { productTourKey: productTourKey },
    },
  ] as const;

export type GetApiProductToursProductTourKeySuspenseQueryKey = ReturnType<
  typeof getApiProductToursProductTourKeySuspenseQueryKey
>;

export function getApiProductToursProductTourKeySuspenseQueryOptions(
  productTourKey: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiProductToursProductTourKeySuspenseQueryKey(productTourKey);
  return queryOptions<
    GetApiProductToursProductTourKeyQueryResponseSchema,
    ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>,
    GetApiProductToursProductTourKeyQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!productTourKey,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProductToursProductTourKey(productTourKey, config);
    },
  });
}

/**
 * @summary Retrieves the product tour status for the user
 * {@link /api/product_tours/:product_tour_key}
 */
export function useGetApiProductToursProductTourKeySuspense<
  TData = GetApiProductToursProductTourKeyQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProductToursProductTourKeySuspenseQueryKey,
>(
  productTourKey: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key'],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProductToursProductTourKeyQueryResponseSchema,
        ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProductToursProductTourKeySuspenseQueryKey(productTourKey);

  const query = useSuspenseQuery(
    {
      ...getApiProductToursProductTourKeySuspenseQueryOptions(productTourKey, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdPathParamsSchema['project_id']
) => ['global', { url: '/api/projects/:project_id', params: { projectId: projectId } }] as const;

export type GetApiProjectsProjectIdSuspenseQueryKey = ReturnType<typeof getApiProjectsProjectIdSuspenseQueryKey>;

export function getApiProjectsProjectIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getApiProjectsProjectIdSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdQueryResponseSchema,
    ResponseErrorConfig<GetApiProjectsProjectId404Schema>,
    GetApiProjectsProjectIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectId(projectId, config);
    },
  });
}

/**
 * @summary Retrieves a project
 * {@link /api/projects/:project_id}
 */
export function useGetApiProjectsProjectIdSuspense<
  TData = GetApiProjectsProjectIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdPathParamsSchema['project_id'],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdQueryResponseSchema,
        ResponseErrorConfig<GetApiProjectsProjectId404Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProjectsProjectIdSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdSuspenseQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiProjectsProjectId404Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiSessionsSuspenseQueryKey = () => ['global', { url: '/api/sessions' }] as const;

export type GetApiSessionsSuspenseQueryKey = ReturnType<typeof getApiSessionsSuspenseQueryKey>;

export function getApiSessionsSuspenseQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiSessionsSuspenseQueryKey();
  return queryOptions<
    GetApiSessionsQueryResponseSchema,
    ResponseErrorConfig<GetApiSessions401Schema>,
    GetApiSessionsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiSessions(config);
    },
  });
}

/**
 * @summary Retrieves current user's active sessions
 * {@link /api/sessions}
 */
export function useGetApiSessionsSuspense<
  TData = GetApiSessionsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiSessionsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiSessionsQueryResponseSchema,
        ResponseErrorConfig<GetApiSessions401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiSessionsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiSessionsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiSessions401Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiTimeZonesSuspenseQueryKey = () => ['global', { url: '/api/time_zones' }] as const;

export type GetApiTimeZonesSuspenseQueryKey = ReturnType<typeof getApiTimeZonesSuspenseQueryKey>;

export function getApiTimeZonesSuspenseQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiTimeZonesSuspenseQueryKey();
  return queryOptions<
    GetApiTimeZonesQueryResponseSchema,
    ResponseErrorConfig<GetApiTimeZones401Schema>,
    GetApiTimeZonesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiTimeZones(config);
    },
  });
}

/**
 * @summary Retrieves time zones
 * {@link /api/time_zones}
 */
export function useGetApiTimeZonesSuspense<
  TData = GetApiTimeZonesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiTimeZonesSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiTimeZonesQueryResponseSchema,
        ResponseErrorConfig<GetApiTimeZones401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiTimeZonesSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiTimeZonesSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiTimeZones401Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiUsersMeSuspenseQueryKey = () => ['global', { url: '/api/users/me' }] as const;

export type GetApiUsersMeSuspenseQueryKey = ReturnType<typeof getApiUsersMeSuspenseQueryKey>;

export function getApiUsersMeSuspenseQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getApiUsersMeSuspenseQueryKey();
  return queryOptions<
    GetApiUsersMeQueryResponseSchema,
    ResponseErrorConfig<GetApiUsersMe401Schema>,
    GetApiUsersMeQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiUsersMe(config);
    },
  });
}

/**
 * @summary Retrieves current user
 * {@link /api/users/me}
 */
export function useGetApiUsersMeSuspense<
  TData = GetApiUsersMeQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiUsersMeSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiUsersMeQueryResponseSchema,
        ResponseErrorConfig<GetApiUsersMe401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiUsersMeSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiUsersMeSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetApiUsersMe401Schema>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const postApiAgreementsAcceptEuaMutationKey = () => [{ url: '/api/agreements/accept_eua' }] as const;

export type PostApiAgreementsAcceptEuaMutationKey = ReturnType<typeof postApiAgreementsAcceptEuaMutationKey>;

export function postApiAgreementsAcceptEuaMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiAgreementsAcceptEuaMutationKey();
  return mutationOptions<
    PostApiAgreementsAcceptEuaMutationResponseSchema,
    ResponseErrorConfig<PostApiAgreementsAcceptEua400Schema | PostApiAgreementsAcceptEua401Schema>,
    { params?: PostApiAgreementsAcceptEuaQueryParamsSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return postApiAgreementsAcceptEua(params, config);
    },
  });
}

/**
 * @description After accepting the agreement, the authentication tokens need to be refreshed.
 * @summary Accepts the End User Agreement for the current user
 * {@link /api/agreements/accept_eua}
 */
export function usePostApiAgreementsAcceptEua<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiAgreementsAcceptEuaMutationResponseSchema,
      ResponseErrorConfig<PostApiAgreementsAcceptEua400Schema | PostApiAgreementsAcceptEua401Schema>,
      { params?: PostApiAgreementsAcceptEuaQueryParamsSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiAgreementsAcceptEuaMutationKey();

  const baseOptions = postApiAgreementsAcceptEuaMutationOptions(config) as UseMutationOptions<
    PostApiAgreementsAcceptEuaMutationResponseSchema,
    ResponseErrorConfig<PostApiAgreementsAcceptEua400Schema | PostApiAgreementsAcceptEua401Schema>,
    { params?: PostApiAgreementsAcceptEuaQueryParamsSchema },
    TContext
  >;

  return useMutation<
    PostApiAgreementsAcceptEuaMutationResponseSchema,
    ResponseErrorConfig<PostApiAgreementsAcceptEua400Schema | PostApiAgreementsAcceptEua401Schema>,
    { params?: PostApiAgreementsAcceptEuaQueryParamsSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiAgreementsAcceptEuaMutationResponseSchema,
    ResponseErrorConfig<PostApiAgreementsAcceptEua400Schema | PostApiAgreementsAcceptEua401Schema>,
    { params?: PostApiAgreementsAcceptEuaQueryParamsSchema },
    TContext
  >;
}

export const postApiAnalyticalEventsMutationKey = () => [{ url: '/api/analytical/events' }] as const;

export type PostApiAnalyticalEventsMutationKey = ReturnType<typeof postApiAnalyticalEventsMutationKey>;

export function postApiAnalyticalEventsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiAnalyticalEventsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiAnalyticalEventsMutationKey();
  return mutationOptions<
    PostApiAnalyticalEventsMutationResponseSchema,
    ResponseErrorConfig<PostApiAnalyticalEvents400Schema | PostApiAnalyticalEvents401Schema>,
    {
      data: PostApiAnalyticalEventsMutationRequestSchema;
      headers?: PostApiAnalyticalEventsHeaderParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data, headers }) => {
      return postApiAnalyticalEvents(data, headers, config);
    },
  });
}

/**
 * @summary Tracks analytical events
 * {@link /api/analytical/events}
 */
export function usePostApiAnalyticalEvents<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiAnalyticalEventsMutationResponseSchema,
      ResponseErrorConfig<PostApiAnalyticalEvents400Schema | PostApiAnalyticalEvents401Schema>,
      {
        data: PostApiAnalyticalEventsMutationRequestSchema;
        headers?: PostApiAnalyticalEventsHeaderParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiAnalyticalEventsMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiAnalyticalEventsMutationKey();

  const baseOptions = postApiAnalyticalEventsMutationOptions(config) as UseMutationOptions<
    PostApiAnalyticalEventsMutationResponseSchema,
    ResponseErrorConfig<PostApiAnalyticalEvents400Schema | PostApiAnalyticalEvents401Schema>,
    {
      data: PostApiAnalyticalEventsMutationRequestSchema;
      headers?: PostApiAnalyticalEventsHeaderParamsSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiAnalyticalEventsMutationResponseSchema,
    ResponseErrorConfig<PostApiAnalyticalEvents400Schema | PostApiAnalyticalEvents401Schema>,
    {
      data: PostApiAnalyticalEventsMutationRequestSchema;
      headers?: PostApiAnalyticalEventsHeaderParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiAnalyticalEventsMutationResponseSchema,
    ResponseErrorConfig<PostApiAnalyticalEvents400Schema | PostApiAnalyticalEvents401Schema>,
    {
      data: PostApiAnalyticalEventsMutationRequestSchema;
      headers?: PostApiAnalyticalEventsHeaderParamsSchema;
    },
    TContext
  >;
}

export const postApiLoginMutationKey = () => [{ url: '/api/login' }] as const;

export type PostApiLoginMutationKey = ReturnType<typeof postApiLoginMutationKey>;

export function postApiLoginMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiLoginMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = postApiLoginMutationKey();
  return mutationOptions<
    PostApiLoginMutationResponseSchema,
    ResponseErrorConfig<PostApiLogin400Schema | PostApiLogin401Schema | PostApiLogin422Schema>,
    { data: PostApiLoginMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiLogin(data, config);
    },
  });
}

/**
 * @summary Authenticates a user
 * {@link /api/login}
 */
export function usePostApiLogin<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiLoginMutationResponseSchema,
      ResponseErrorConfig<PostApiLogin400Schema | PostApiLogin401Schema | PostApiLogin422Schema>,
      { data: PostApiLoginMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiLoginMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiLoginMutationKey();

  const baseOptions = postApiLoginMutationOptions(config) as UseMutationOptions<
    PostApiLoginMutationResponseSchema,
    ResponseErrorConfig<PostApiLogin400Schema | PostApiLogin401Schema | PostApiLogin422Schema>,
    { data: PostApiLoginMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiLoginMutationResponseSchema,
    ResponseErrorConfig<PostApiLogin400Schema | PostApiLogin401Schema | PostApiLogin422Schema>,
    { data: PostApiLoginMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiLoginMutationResponseSchema,
    ResponseErrorConfig<PostApiLogin400Schema | PostApiLogin401Schema | PostApiLogin422Schema>,
    { data: PostApiLoginMutationRequestSchema },
    TContext
  >;
}

export const deleteApiLogoutMutationKey = () => [{ url: '/api/logout' }] as const;

export type DeleteApiLogoutMutationKey = ReturnType<typeof deleteApiLogoutMutationKey>;

export function deleteApiLogoutMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteApiLogoutMutationKey();
  return mutationOptions<
    DeleteApiLogoutMutationResponseSchema,
    ResponseErrorConfig<DeleteApiLogout401Schema | DeleteApiLogout422Schema>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return deleteApiLogout(config);
    },
  });
}

/**
 * @summary Logs out a user
 * {@link /api/logout}
 */
export function useDeleteApiLogout<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiLogoutMutationResponseSchema,
      ResponseErrorConfig<DeleteApiLogout401Schema | DeleteApiLogout422Schema>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteApiLogoutMutationKey();

  const baseOptions = deleteApiLogoutMutationOptions(config) as UseMutationOptions<
    DeleteApiLogoutMutationResponseSchema,
    ResponseErrorConfig<DeleteApiLogout401Schema | DeleteApiLogout422Schema>,
    void,
    TContext
  >;

  return useMutation<
    DeleteApiLogoutMutationResponseSchema,
    ResponseErrorConfig<DeleteApiLogout401Schema | DeleteApiLogout422Schema>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    DeleteApiLogoutMutationResponseSchema,
    ResponseErrorConfig<DeleteApiLogout401Schema | DeleteApiLogout422Schema>,
    void,
    TContext
  >;
}

export const postApiAuthenticationMutationKey = () => [{ url: '/api/authentication' }] as const;

export type PostApiAuthenticationMutationKey = ReturnType<typeof postApiAuthenticationMutationKey>;

export function postApiAuthenticationMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiAuthenticationMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = postApiAuthenticationMutationKey();
  return mutationOptions<
    PostApiAuthenticationMutationResponseSchema,
    ResponseErrorConfig<PostApiAuthentication400Schema>,
    { data: PostApiAuthenticationMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiAuthentication(data, config);
    },
  });
}

/**
 * @summary Attempts a login with a provider or checks if the account exists
 * {@link /api/authentication}
 */
export function usePostApiAuthentication<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiAuthenticationMutationResponseSchema,
      ResponseErrorConfig<PostApiAuthentication400Schema>,
      { data: PostApiAuthenticationMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiAuthenticationMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiAuthenticationMutationKey();

  const baseOptions = postApiAuthenticationMutationOptions(config) as UseMutationOptions<
    PostApiAuthenticationMutationResponseSchema,
    ResponseErrorConfig<PostApiAuthentication400Schema>,
    { data: PostApiAuthenticationMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiAuthenticationMutationResponseSchema,
    ResponseErrorConfig<PostApiAuthentication400Schema>,
    { data: PostApiAuthenticationMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiAuthenticationMutationResponseSchema,
    ResponseErrorConfig<PostApiAuthentication400Schema>,
    { data: PostApiAuthenticationMutationRequestSchema },
    TContext
  >;
}

export const postApiChannelsDevicesMutationKey = () => [{ url: '/api/channels/devices' }] as const;

export type PostApiChannelsDevicesMutationKey = ReturnType<typeof postApiChannelsDevicesMutationKey>;

export function postApiChannelsDevicesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiChannelsDevicesMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiChannelsDevicesMutationKey();
  return mutationOptions<
    PostApiChannelsDevicesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiChannelsDevices400Schema | PostApiChannelsDevices401Schema | PostApiChannelsDevices422Schema
    >,
    { data: PostApiChannelsDevicesMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiChannelsDevices(data, config);
    },
  });
}

/**
 * @summary Adds a device
 * {@link /api/channels/devices}
 */
export function usePostApiChannelsDevices<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiChannelsDevicesMutationResponseSchema,
      ResponseErrorConfig<
        PostApiChannelsDevices400Schema | PostApiChannelsDevices401Schema | PostApiChannelsDevices422Schema
      >,
      { data: PostApiChannelsDevicesMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiChannelsDevicesMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiChannelsDevicesMutationKey();

  const baseOptions = postApiChannelsDevicesMutationOptions(config) as UseMutationOptions<
    PostApiChannelsDevicesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiChannelsDevices400Schema | PostApiChannelsDevices401Schema | PostApiChannelsDevices422Schema
    >,
    { data: PostApiChannelsDevicesMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiChannelsDevicesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiChannelsDevices400Schema | PostApiChannelsDevices401Schema | PostApiChannelsDevices422Schema
    >,
    { data: PostApiChannelsDevicesMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiChannelsDevicesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiChannelsDevices400Schema | PostApiChannelsDevices401Schema | PostApiChannelsDevices422Schema
    >,
    { data: PostApiChannelsDevicesMutationRequestSchema },
    TContext
  >;
}

export const deleteApiChannelsDevicesDeviceIdMutationKey = () => [{ url: '/api/channels/devices/:device_id' }] as const;

export type DeleteApiChannelsDevicesDeviceIdMutationKey = ReturnType<
  typeof deleteApiChannelsDevicesDeviceIdMutationKey
>;

export function deleteApiChannelsDevicesDeviceIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteApiChannelsDevicesDeviceIdMutationKey();
  return mutationOptions<
    DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
    ResponseErrorConfig<DeleteApiChannelsDevicesDeviceId401Schema>,
    { deviceId: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id'] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ deviceId }) => {
      return deleteApiChannelsDevicesDeviceId(deviceId, config);
    },
  });
}

/**
 * @summary Deletes a device
 * {@link /api/channels/devices/:device_id}
 */
export function useDeleteApiChannelsDevicesDeviceId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
      ResponseErrorConfig<DeleteApiChannelsDevicesDeviceId401Schema>,
      {
        deviceId: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id'];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteApiChannelsDevicesDeviceIdMutationKey();

  const baseOptions = deleteApiChannelsDevicesDeviceIdMutationOptions(config) as UseMutationOptions<
    DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
    ResponseErrorConfig<DeleteApiChannelsDevicesDeviceId401Schema>,
    { deviceId: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id'] },
    TContext
  >;

  return useMutation<
    DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
    ResponseErrorConfig<DeleteApiChannelsDevicesDeviceId401Schema>,
    { deviceId: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id'] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
    ResponseErrorConfig<DeleteApiChannelsDevicesDeviceId401Schema>,
    { deviceId: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id'] },
    TContext
  >;
}

export const postApiDirectUploadsUserAvatarMutationKey = () => [{ url: '/api/direct_uploads/user_avatar' }] as const;

export type PostApiDirectUploadsUserAvatarMutationKey = ReturnType<typeof postApiDirectUploadsUserAvatarMutationKey>;

export function postApiDirectUploadsUserAvatarMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiDirectUploadsUserAvatarMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiDirectUploadsUserAvatarMutationKey();
  return mutationOptions<
    PostApiDirectUploadsUserAvatarMutationResponseSchema,
    ResponseErrorConfig<PostApiDirectUploadsUserAvatar400Schema | PostApiDirectUploadsUserAvatar401Schema>,
    { data: PostApiDirectUploadsUserAvatarMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiDirectUploadsUserAvatar(data, config);
    },
  });
}

/**
 * @summary Creates a direct upload for the user avatar
 * {@link /api/direct_uploads/user_avatar}
 */
export function usePostApiDirectUploadsUserAvatar<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiDirectUploadsUserAvatarMutationResponseSchema,
      ResponseErrorConfig<PostApiDirectUploadsUserAvatar400Schema | PostApiDirectUploadsUserAvatar401Schema>,
      { data: PostApiDirectUploadsUserAvatarMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiDirectUploadsUserAvatarMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiDirectUploadsUserAvatarMutationKey();

  const baseOptions = postApiDirectUploadsUserAvatarMutationOptions(config) as UseMutationOptions<
    PostApiDirectUploadsUserAvatarMutationResponseSchema,
    ResponseErrorConfig<PostApiDirectUploadsUserAvatar400Schema | PostApiDirectUploadsUserAvatar401Schema>,
    { data: PostApiDirectUploadsUserAvatarMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiDirectUploadsUserAvatarMutationResponseSchema,
    ResponseErrorConfig<PostApiDirectUploadsUserAvatar400Schema | PostApiDirectUploadsUserAvatar401Schema>,
    { data: PostApiDirectUploadsUserAvatarMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiDirectUploadsUserAvatarMutationResponseSchema,
    ResponseErrorConfig<PostApiDirectUploadsUserAvatar400Schema | PostApiDirectUploadsUserAvatar401Schema>,
    { data: PostApiDirectUploadsUserAvatarMutationRequestSchema },
    TContext
  >;
}

export const patchApiEmailPreferencesMutationKey = () => [{ url: '/api/email_preferences' }] as const;

export type PatchApiEmailPreferencesMutationKey = ReturnType<typeof patchApiEmailPreferencesMutationKey>;

export function patchApiEmailPreferencesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiEmailPreferencesMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = patchApiEmailPreferencesMutationKey();
  return mutationOptions<
    PatchApiEmailPreferencesMutationResponseSchema,
    ResponseErrorConfig<PatchApiEmailPreferences401Schema | PatchApiEmailPreferences422Schema>,
    { data?: PatchApiEmailPreferencesMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return patchApiEmailPreferences(data, config);
    },
  });
}

/**
 * @summary Updates the delivery type for each provided category
 * {@link /api/email_preferences}
 */
export function usePatchApiEmailPreferences<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiEmailPreferencesMutationResponseSchema,
      ResponseErrorConfig<PatchApiEmailPreferences401Schema | PatchApiEmailPreferences422Schema>,
      { data?: PatchApiEmailPreferencesMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiEmailPreferencesMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchApiEmailPreferencesMutationKey();

  const baseOptions = patchApiEmailPreferencesMutationOptions(config) as UseMutationOptions<
    PatchApiEmailPreferencesMutationResponseSchema,
    ResponseErrorConfig<PatchApiEmailPreferences401Schema | PatchApiEmailPreferences422Schema>,
    { data?: PatchApiEmailPreferencesMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PatchApiEmailPreferencesMutationResponseSchema,
    ResponseErrorConfig<PatchApiEmailPreferences401Schema | PatchApiEmailPreferences422Schema>,
    { data?: PatchApiEmailPreferencesMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PatchApiEmailPreferencesMutationResponseSchema,
    ResponseErrorConfig<PatchApiEmailPreferences401Schema | PatchApiEmailPreferences422Schema>,
    { data?: PatchApiEmailPreferencesMutationRequestSchema },
    TContext
  >;
}

export const postApiFeedbacksMutationKey = () => [{ url: '/api/feedbacks' }] as const;

export type PostApiFeedbacksMutationKey = ReturnType<typeof postApiFeedbacksMutationKey>;

export function postApiFeedbacksMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiFeedbacksMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = postApiFeedbacksMutationKey();
  return mutationOptions<
    PostApiFeedbacksMutationResponseSchema,
    ResponseErrorConfig<PostApiFeedbacks401Schema | PostApiFeedbacks422Schema>,
    { data?: PostApiFeedbacksMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiFeedbacks(data, config);
    },
  });
}

/**
 * @summary Creates a feedback
 * {@link /api/feedbacks}
 */
export function usePostApiFeedbacks<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiFeedbacksMutationResponseSchema,
      ResponseErrorConfig<PostApiFeedbacks401Schema | PostApiFeedbacks422Schema>,
      { data?: PostApiFeedbacksMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiFeedbacksMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiFeedbacksMutationKey();

  const baseOptions = postApiFeedbacksMutationOptions(config) as UseMutationOptions<
    PostApiFeedbacksMutationResponseSchema,
    ResponseErrorConfig<PostApiFeedbacks401Schema | PostApiFeedbacks422Schema>,
    { data?: PostApiFeedbacksMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiFeedbacksMutationResponseSchema,
    ResponseErrorConfig<PostApiFeedbacks401Schema | PostApiFeedbacks422Schema>,
    { data?: PostApiFeedbacksMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiFeedbacksMutationResponseSchema,
    ResponseErrorConfig<PostApiFeedbacks401Schema | PostApiFeedbacks422Schema>,
    { data?: PostApiFeedbacksMutationRequestSchema },
    TContext
  >;
}

export const postOauthAuthorizeMutationKey = () => [{ url: '/oauth/authorize' }] as const;

export type PostOauthAuthorizeMutationKey = ReturnType<typeof postOauthAuthorizeMutationKey>;

export function postOauthAuthorizeMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostOauthAuthorizeMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = postOauthAuthorizeMutationKey();
  return mutationOptions<
    PostOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<PostOauthAuthorize400Schema | PostOauthAuthorize401Schema>,
    { data?: PostOauthAuthorizeMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postOauthAuthorize(data, config);
    },
  });
}

/**
 * @description Confirms the consent collected from the pre-authorization payload andissues the authorization code, using the parameters the pre-authorizationwas requested with.
 * @summary Grant consent and issue the authorization code
 * {@link /oauth/authorize}
 */
export function usePostOauthAuthorize<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostOauthAuthorizeMutationResponseSchema,
      ResponseErrorConfig<PostOauthAuthorize400Schema | PostOauthAuthorize401Schema>,
      { data?: PostOauthAuthorizeMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostOauthAuthorizeMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postOauthAuthorizeMutationKey();

  const baseOptions = postOauthAuthorizeMutationOptions(config) as UseMutationOptions<
    PostOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<PostOauthAuthorize400Schema | PostOauthAuthorize401Schema>,
    { data?: PostOauthAuthorizeMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<PostOauthAuthorize400Schema | PostOauthAuthorize401Schema>,
    { data?: PostOauthAuthorizeMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<PostOauthAuthorize400Schema | PostOauthAuthorize401Schema>,
    { data?: PostOauthAuthorizeMutationRequestSchema },
    TContext
  >;
}

export const deleteOauthAuthorizeMutationKey = () => [{ url: '/oauth/authorize' }] as const;

export type DeleteOauthAuthorizeMutationKey = ReturnType<typeof deleteOauthAuthorizeMutationKey>;

export function deleteOauthAuthorizeMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteOauthAuthorizeMutationKey();
  return mutationOptions<
    DeleteOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<DeleteOauthAuthorize400Schema | DeleteOauthAuthorize401Schema>,
    { params?: DeleteOauthAuthorizeQueryParamsSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return deleteOauthAuthorize(params, config);
    },
  });
}

/**
 * @description Denies the authorization request. No access grant is issued.
 * @summary Deny consent
 * {@link /oauth/authorize}
 */
export function useDeleteOauthAuthorize<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteOauthAuthorizeMutationResponseSchema,
      ResponseErrorConfig<DeleteOauthAuthorize400Schema | DeleteOauthAuthorize401Schema>,
      { params?: DeleteOauthAuthorizeQueryParamsSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteOauthAuthorizeMutationKey();

  const baseOptions = deleteOauthAuthorizeMutationOptions(config) as UseMutationOptions<
    DeleteOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<DeleteOauthAuthorize400Schema | DeleteOauthAuthorize401Schema>,
    { params?: DeleteOauthAuthorizeQueryParamsSchema },
    TContext
  >;

  return useMutation<
    DeleteOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<DeleteOauthAuthorize400Schema | DeleteOauthAuthorize401Schema>,
    { params?: DeleteOauthAuthorizeQueryParamsSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    DeleteOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<DeleteOauthAuthorize400Schema | DeleteOauthAuthorize401Schema>,
    { params?: DeleteOauthAuthorizeQueryParamsSchema },
    TContext
  >;
}

export const deleteApiOauthAuthorizedApplicationsMutationKey = () =>
  [{ url: '/api/oauth/authorized_applications' }] as const;

export type DeleteApiOauthAuthorizedApplicationsMutationKey = ReturnType<
  typeof deleteApiOauthAuthorizedApplicationsMutationKey
>;

export function deleteApiOauthAuthorizedApplicationsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteApiOauthAuthorizedApplicationsMutationKey();
  return mutationOptions<
    DeleteApiOauthAuthorizedApplicationsMutationResponseSchema,
    ResponseErrorConfig<DeleteApiOauthAuthorizedApplications400Schema | DeleteApiOauthAuthorizedApplications401Schema>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return deleteApiOauthAuthorizedApplications(config);
    },
  });
}

/**
 * @summary Revokes the access of all OAuth applications authorised by the current user
 * {@link /api/oauth/authorized_applications}
 */
export function useDeleteApiOauthAuthorizedApplications<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiOauthAuthorizedApplicationsMutationResponseSchema,
      ResponseErrorConfig<
        DeleteApiOauthAuthorizedApplications400Schema | DeleteApiOauthAuthorizedApplications401Schema
      >,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteApiOauthAuthorizedApplicationsMutationKey();

  const baseOptions = deleteApiOauthAuthorizedApplicationsMutationOptions(config) as UseMutationOptions<
    DeleteApiOauthAuthorizedApplicationsMutationResponseSchema,
    ResponseErrorConfig<DeleteApiOauthAuthorizedApplications400Schema | DeleteApiOauthAuthorizedApplications401Schema>,
    void,
    TContext
  >;

  return useMutation<
    DeleteApiOauthAuthorizedApplicationsMutationResponseSchema,
    ResponseErrorConfig<DeleteApiOauthAuthorizedApplications400Schema | DeleteApiOauthAuthorizedApplications401Schema>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    DeleteApiOauthAuthorizedApplicationsMutationResponseSchema,
    ResponseErrorConfig<DeleteApiOauthAuthorizedApplications400Schema | DeleteApiOauthAuthorizedApplications401Schema>,
    void,
    TContext
  >;
}

export const deleteApiOauthAuthorizedApplicationsApplicationIdMutationKey = () =>
  [{ url: '/api/oauth/authorized_applications/:application_id' }] as const;

export type DeleteApiOauthAuthorizedApplicationsApplicationIdMutationKey = ReturnType<
  typeof deleteApiOauthAuthorizedApplicationsApplicationIdMutationKey
>;

export function deleteApiOauthAuthorizedApplicationsApplicationIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteApiOauthAuthorizedApplicationsApplicationIdMutationKey();
  return mutationOptions<
    DeleteApiOauthAuthorizedApplicationsApplicationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiOauthAuthorizedApplicationsApplicationId400Schema
      | DeleteApiOauthAuthorizedApplicationsApplicationId401Schema
    >,
    {
      applicationId: DeleteApiOauthAuthorizedApplicationsApplicationIdPathParamsSchema['application_id'];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ applicationId }) => {
      return deleteApiOauthAuthorizedApplicationsApplicationId(applicationId, config);
    },
  });
}

/**
 * @summary Revokes the access of an OAuth application authorised by the current user
 * {@link /api/oauth/authorized_applications/:application_id}
 */
export function useDeleteApiOauthAuthorizedApplicationsApplicationId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiOauthAuthorizedApplicationsApplicationIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiOauthAuthorizedApplicationsApplicationId400Schema
        | DeleteApiOauthAuthorizedApplicationsApplicationId401Schema
      >,
      {
        applicationId: DeleteApiOauthAuthorizedApplicationsApplicationIdPathParamsSchema['application_id'];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteApiOauthAuthorizedApplicationsApplicationIdMutationKey();

  const baseOptions = deleteApiOauthAuthorizedApplicationsApplicationIdMutationOptions(config) as UseMutationOptions<
    DeleteApiOauthAuthorizedApplicationsApplicationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiOauthAuthorizedApplicationsApplicationId400Schema
      | DeleteApiOauthAuthorizedApplicationsApplicationId401Schema
    >,
    {
      applicationId: DeleteApiOauthAuthorizedApplicationsApplicationIdPathParamsSchema['application_id'];
    },
    TContext
  >;

  return useMutation<
    DeleteApiOauthAuthorizedApplicationsApplicationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiOauthAuthorizedApplicationsApplicationId400Schema
      | DeleteApiOauthAuthorizedApplicationsApplicationId401Schema
    >,
    {
      applicationId: DeleteApiOauthAuthorizedApplicationsApplicationIdPathParamsSchema['application_id'];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    DeleteApiOauthAuthorizedApplicationsApplicationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiOauthAuthorizedApplicationsApplicationId400Schema
      | DeleteApiOauthAuthorizedApplicationsApplicationId401Schema
    >,
    {
      applicationId: DeleteApiOauthAuthorizedApplicationsApplicationIdPathParamsSchema['application_id'];
    },
    TContext
  >;
}

export const patchApiOnboardingMutationKey = () => [{ url: '/api/onboarding' }] as const;

export type PatchApiOnboardingMutationKey = ReturnType<typeof patchApiOnboardingMutationKey>;

export function patchApiOnboardingMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiOnboardingMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = patchApiOnboardingMutationKey();
  return mutationOptions<
    PatchApiOnboardingMutationResponseSchema,
    ResponseErrorConfig<PatchApiOnboarding401Schema | PatchApiOnboarding404Schema>,
    { data?: PatchApiOnboardingMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return patchApiOnboarding(data, config);
    },
  });
}

/**
 * @summary Updates the current user onboarding
 * {@link /api/onboarding}
 */
export function usePatchApiOnboarding<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiOnboardingMutationResponseSchema,
      ResponseErrorConfig<PatchApiOnboarding401Schema | PatchApiOnboarding404Schema>,
      { data?: PatchApiOnboardingMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiOnboardingMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchApiOnboardingMutationKey();

  const baseOptions = patchApiOnboardingMutationOptions(config) as UseMutationOptions<
    PatchApiOnboardingMutationResponseSchema,
    ResponseErrorConfig<PatchApiOnboarding401Schema | PatchApiOnboarding404Schema>,
    { data?: PatchApiOnboardingMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PatchApiOnboardingMutationResponseSchema,
    ResponseErrorConfig<PatchApiOnboarding401Schema | PatchApiOnboarding404Schema>,
    { data?: PatchApiOnboardingMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PatchApiOnboardingMutationResponseSchema,
    ResponseErrorConfig<PatchApiOnboarding401Schema | PatchApiOnboarding404Schema>,
    { data?: PatchApiOnboardingMutationRequestSchema },
    TContext
  >;
}

export const postApiOnboardingFinishMutationKey = () => [{ url: '/api/onboarding/finish' }] as const;

export type PostApiOnboardingFinishMutationKey = ReturnType<typeof postApiOnboardingFinishMutationKey>;

export function postApiOnboardingFinishMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiOnboardingFinishMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiOnboardingFinishMutationKey();
  return mutationOptions<
    PostApiOnboardingFinishMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOnboardingFinish401Schema | PostApiOnboardingFinish404Schema | PostApiOnboardingFinish422Schema
    >,
    { data?: PostApiOnboardingFinishMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiOnboardingFinish(data, config);
    },
  });
}

/**
 * @summary Finishes onboarding
 * {@link /api/onboarding/finish}
 */
export function usePostApiOnboardingFinish<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiOnboardingFinishMutationResponseSchema,
      ResponseErrorConfig<
        PostApiOnboardingFinish401Schema | PostApiOnboardingFinish404Schema | PostApiOnboardingFinish422Schema
      >,
      { data?: PostApiOnboardingFinishMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiOnboardingFinishMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiOnboardingFinishMutationKey();

  const baseOptions = postApiOnboardingFinishMutationOptions(config) as UseMutationOptions<
    PostApiOnboardingFinishMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOnboardingFinish401Schema | PostApiOnboardingFinish404Schema | PostApiOnboardingFinish422Schema
    >,
    { data?: PostApiOnboardingFinishMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiOnboardingFinishMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOnboardingFinish401Schema | PostApiOnboardingFinish404Schema | PostApiOnboardingFinish422Schema
    >,
    { data?: PostApiOnboardingFinishMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiOnboardingFinishMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOnboardingFinish401Schema | PostApiOnboardingFinish404Schema | PostApiOnboardingFinish422Schema
    >,
    { data?: PostApiOnboardingFinishMutationRequestSchema },
    TContext
  >;
}

export const patchApiProductToursProductTourKeyMutationKey = () =>
  [{ url: '/api/product_tours/:product_tour_key' }] as const;

export type PatchApiProductToursProductTourKeyMutationKey = ReturnType<
  typeof patchApiProductToursProductTourKeyMutationKey
>;

export function patchApiProductToursProductTourKeyMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiProductToursProductTourKeyMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = patchApiProductToursProductTourKeyMutationKey();
  return mutationOptions<
    PatchApiProductToursProductTourKeyMutationResponseSchema,
    ResponseErrorConfig<PatchApiProductToursProductTourKey401Schema | PatchApiProductToursProductTourKey404Schema>,
    {
      productTourKey: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key'];
      data?: PatchApiProductToursProductTourKeyMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ productTourKey, data }) => {
      return patchApiProductToursProductTourKey(productTourKey, data, config);
    },
  });
}

/**
 * @summary Updates the product tour status for the user
 * {@link /api/product_tours/:product_tour_key}
 */
export function usePatchApiProductToursProductTourKey<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProductToursProductTourKeyMutationResponseSchema,
      ResponseErrorConfig<PatchApiProductToursProductTourKey401Schema | PatchApiProductToursProductTourKey404Schema>,
      {
        productTourKey: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key'];
        data?: PatchApiProductToursProductTourKeyMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiProductToursProductTourKeyMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchApiProductToursProductTourKeyMutationKey();

  const baseOptions = patchApiProductToursProductTourKeyMutationOptions(config) as UseMutationOptions<
    PatchApiProductToursProductTourKeyMutationResponseSchema,
    ResponseErrorConfig<PatchApiProductToursProductTourKey401Schema | PatchApiProductToursProductTourKey404Schema>,
    {
      productTourKey: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key'];
      data?: PatchApiProductToursProductTourKeyMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiProductToursProductTourKeyMutationResponseSchema,
    ResponseErrorConfig<PatchApiProductToursProductTourKey401Schema | PatchApiProductToursProductTourKey404Schema>,
    {
      productTourKey: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key'];
      data?: PatchApiProductToursProductTourKeyMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PatchApiProductToursProductTourKeyMutationResponseSchema,
    ResponseErrorConfig<PatchApiProductToursProductTourKey401Schema | PatchApiProductToursProductTourKey404Schema>,
    {
      productTourKey: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key'];
      data?: PatchApiProductToursProductTourKeyMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdDefaultMutationKey = () => [{ url: '/api/projects/:project_id/default' }] as const;

export type PostApiProjectsProjectIdDefaultMutationKey = ReturnType<typeof postApiProjectsProjectIdDefaultMutationKey>;

export function postApiProjectsProjectIdDefaultMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiProjectsProjectIdDefaultMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdDefaultMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdDefault401Schema>,
    {
      projectId: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id'];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId }) => {
      return postApiProjectsProjectIdDefault(projectId, config);
    },
  });
}

/**
 * @summary Set the default project
 * {@link /api/projects/:project_id/default}
 */
export function usePostApiProjectsProjectIdDefault<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdDefaultMutationResponseSchema,
      ResponseErrorConfig<PostApiProjectsProjectIdDefault401Schema>,
      {
        projectId: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id'];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiProjectsProjectIdDefaultMutationKey();

  const baseOptions = postApiProjectsProjectIdDefaultMutationOptions(config) as UseMutationOptions<
    PostApiProjectsProjectIdDefaultMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdDefault401Schema>,
    {
      projectId: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id'];
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdDefaultMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdDefault401Schema>,
    {
      projectId: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id'];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiProjectsProjectIdDefaultMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdDefault401Schema>,
    {
      projectId: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id'];
    },
    TContext
  >;
}

export const postApiPushSubscriptionsMutationKey = () => [{ url: '/api/push_subscriptions' }] as const;

export type PostApiPushSubscriptionsMutationKey = ReturnType<typeof postApiPushSubscriptionsMutationKey>;

export function postApiPushSubscriptionsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiPushSubscriptionsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiPushSubscriptionsMutationKey();
  return mutationOptions<
    PostApiPushSubscriptionsMutationResponseSchema,
    ResponseErrorConfig<PostApiPushSubscriptions401Schema | PostApiPushSubscriptions422Schema>,
    { data: PostApiPushSubscriptionsMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiPushSubscriptions(data, config);
    },
  });
}

/**
 * @summary Creates a push subscription
 * {@link /api/push_subscriptions}
 */
export function usePostApiPushSubscriptions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiPushSubscriptionsMutationResponseSchema,
      ResponseErrorConfig<PostApiPushSubscriptions401Schema | PostApiPushSubscriptions422Schema>,
      { data: PostApiPushSubscriptionsMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiPushSubscriptionsMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiPushSubscriptionsMutationKey();

  const baseOptions = postApiPushSubscriptionsMutationOptions(config) as UseMutationOptions<
    PostApiPushSubscriptionsMutationResponseSchema,
    ResponseErrorConfig<PostApiPushSubscriptions401Schema | PostApiPushSubscriptions422Schema>,
    { data: PostApiPushSubscriptionsMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiPushSubscriptionsMutationResponseSchema,
    ResponseErrorConfig<PostApiPushSubscriptions401Schema | PostApiPushSubscriptions422Schema>,
    { data: PostApiPushSubscriptionsMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiPushSubscriptionsMutationResponseSchema,
    ResponseErrorConfig<PostApiPushSubscriptions401Schema | PostApiPushSubscriptions422Schema>,
    { data: PostApiPushSubscriptionsMutationRequestSchema },
    TContext
  >;
}

export const patchApiPushSubscriptionsPushSubscriptionIdMutationKey = () =>
  [{ url: '/api/push_subscriptions/:push_subscription_id' }] as const;

export type PatchApiPushSubscriptionsPushSubscriptionIdMutationKey = ReturnType<
  typeof patchApiPushSubscriptionsPushSubscriptionIdMutationKey
>;

export function patchApiPushSubscriptionsPushSubscriptionIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = patchApiPushSubscriptionsPushSubscriptionIdMutationKey();
  return mutationOptions<
    PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      PatchApiPushSubscriptionsPushSubscriptionId401Schema | PatchApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
      data: PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ pushSubscriptionId, data }) => {
      return patchApiPushSubscriptionsPushSubscriptionId(pushSubscriptionId, data, config);
    },
  });
}

/**
 * @summary Updates a push subscription
 * {@link /api/push_subscriptions/:push_subscription_id}
 */
export function usePatchApiPushSubscriptionsPushSubscriptionId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
      ResponseErrorConfig<
        PatchApiPushSubscriptionsPushSubscriptionId401Schema | PatchApiPushSubscriptionsPushSubscriptionId404Schema
      >,
      {
        pushSubscriptionId: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
        data: PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchApiPushSubscriptionsPushSubscriptionIdMutationKey();

  const baseOptions = patchApiPushSubscriptionsPushSubscriptionIdMutationOptions(config) as UseMutationOptions<
    PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      PatchApiPushSubscriptionsPushSubscriptionId401Schema | PatchApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
      data: PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      PatchApiPushSubscriptionsPushSubscriptionId401Schema | PatchApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
      data: PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      PatchApiPushSubscriptionsPushSubscriptionId401Schema | PatchApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
      data: PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiPushSubscriptionsPushSubscriptionIdMutationKey = () =>
  [{ url: '/api/push_subscriptions/:push_subscription_id' }] as const;

export type DeleteApiPushSubscriptionsPushSubscriptionIdMutationKey = ReturnType<
  typeof deleteApiPushSubscriptionsPushSubscriptionIdMutationKey
>;

export function deleteApiPushSubscriptionsPushSubscriptionIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteApiPushSubscriptionsPushSubscriptionIdMutationKey();
  return mutationOptions<
    DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      DeleteApiPushSubscriptionsPushSubscriptionId401Schema | DeleteApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ pushSubscriptionId }) => {
      return deleteApiPushSubscriptionsPushSubscriptionId(pushSubscriptionId, config);
    },
  });
}

/**
 * @summary Deletes a push subscription
 * {@link /api/push_subscriptions/:push_subscription_id}
 */
export function useDeleteApiPushSubscriptionsPushSubscriptionId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
      ResponseErrorConfig<
        DeleteApiPushSubscriptionsPushSubscriptionId401Schema | DeleteApiPushSubscriptionsPushSubscriptionId404Schema
      >,
      {
        pushSubscriptionId: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteApiPushSubscriptionsPushSubscriptionIdMutationKey();

  const baseOptions = deleteApiPushSubscriptionsPushSubscriptionIdMutationOptions(config) as UseMutationOptions<
    DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      DeleteApiPushSubscriptionsPushSubscriptionId401Schema | DeleteApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
    },
    TContext
  >;

  return useMutation<
    DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      DeleteApiPushSubscriptionsPushSubscriptionId401Schema | DeleteApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      DeleteApiPushSubscriptionsPushSubscriptionId401Schema | DeleteApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    {
      pushSubscriptionId: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'];
    },
    TContext
  >;
}

export const postApiServiceTokensMutationKey = () => [{ url: '/api/service_tokens' }] as const;

export type PostApiServiceTokensMutationKey = ReturnType<typeof postApiServiceTokensMutationKey>;

export function postApiServiceTokensMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiServiceTokensMutationKey();
  return mutationOptions<
    PostApiServiceTokensMutationResponseSchema,
    ResponseErrorConfig<PostApiServiceTokens400Schema | PostApiServiceTokens401Schema>,
    { headers: PostApiServiceTokensHeaderParamsSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ headers }) => {
      return postApiServiceTokens(headers, config);
    },
  });
}

/**
 * @summary Creates an access token for a user linked to a service
 * {@link /api/service_tokens}
 */
export function usePostApiServiceTokens<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiServiceTokensMutationResponseSchema,
      ResponseErrorConfig<PostApiServiceTokens400Schema | PostApiServiceTokens401Schema>,
      { headers: PostApiServiceTokensHeaderParamsSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiServiceTokensMutationKey();

  const baseOptions = postApiServiceTokensMutationOptions(config) as UseMutationOptions<
    PostApiServiceTokensMutationResponseSchema,
    ResponseErrorConfig<PostApiServiceTokens400Schema | PostApiServiceTokens401Schema>,
    { headers: PostApiServiceTokensHeaderParamsSchema },
    TContext
  >;

  return useMutation<
    PostApiServiceTokensMutationResponseSchema,
    ResponseErrorConfig<PostApiServiceTokens400Schema | PostApiServiceTokens401Schema>,
    { headers: PostApiServiceTokensHeaderParamsSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiServiceTokensMutationResponseSchema,
    ResponseErrorConfig<PostApiServiceTokens400Schema | PostApiServiceTokens401Schema>,
    { headers: PostApiServiceTokensHeaderParamsSchema },
    TContext
  >;
}

export const postApiLoginRefreshMutationKey = () => [{ url: '/api/login/refresh' }] as const;

export type PostApiLoginRefreshMutationKey = ReturnType<typeof postApiLoginRefreshMutationKey>;

export function postApiLoginRefreshMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiLoginRefreshMutationKey();
  return mutationOptions<
    PostApiLoginRefreshMutationResponseSchema,
    ResponseErrorConfig<PostApiLoginRefresh400Schema | PostApiLoginRefresh401Schema>,
    { headers: PostApiLoginRefreshHeaderParamsSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ headers }) => {
      return postApiLoginRefresh(headers, config);
    },
  });
}

/**
 * @summary Refreshes user authentication
 * {@link /api/login/refresh}
 */
export function usePostApiLoginRefresh<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiLoginRefreshMutationResponseSchema,
      ResponseErrorConfig<PostApiLoginRefresh400Schema | PostApiLoginRefresh401Schema>,
      { headers: PostApiLoginRefreshHeaderParamsSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiLoginRefreshMutationKey();

  const baseOptions = postApiLoginRefreshMutationOptions(config) as UseMutationOptions<
    PostApiLoginRefreshMutationResponseSchema,
    ResponseErrorConfig<PostApiLoginRefresh400Schema | PostApiLoginRefresh401Schema>,
    { headers: PostApiLoginRefreshHeaderParamsSchema },
    TContext
  >;

  return useMutation<
    PostApiLoginRefreshMutationResponseSchema,
    ResponseErrorConfig<PostApiLoginRefresh400Schema | PostApiLoginRefresh401Schema>,
    { headers: PostApiLoginRefreshHeaderParamsSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiLoginRefreshMutationResponseSchema,
    ResponseErrorConfig<PostApiLoginRefresh400Schema | PostApiLoginRefresh401Schema>,
    { headers: PostApiLoginRefreshHeaderParamsSchema },
    TContext
  >;
}

export const postApiUsersConfirmationInstructionsMutationKey = () =>
  [{ url: '/api/users/confirmation/instructions' }] as const;

export type PostApiUsersConfirmationInstructionsMutationKey = ReturnType<
  typeof postApiUsersConfirmationInstructionsMutationKey
>;

export function postApiUsersConfirmationInstructionsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiUsersConfirmationInstructionsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = postApiUsersConfirmationInstructionsMutationKey();
  return mutationOptions<
    PostApiUsersConfirmationInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersConfirmationInstructionsMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiUsersConfirmationInstructions(data, config);
    },
  });
}

/**
 * @summary Sends a confirmation email
 * {@link /api/users/confirmation/instructions}
 */
export function usePostApiUsersConfirmationInstructions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiUsersConfirmationInstructionsMutationResponseSchema,
      ResponseErrorConfig<Error>,
      { data: PostApiUsersConfirmationInstructionsMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiUsersConfirmationInstructionsMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiUsersConfirmationInstructionsMutationKey();

  const baseOptions = postApiUsersConfirmationInstructionsMutationOptions(config) as UseMutationOptions<
    PostApiUsersConfirmationInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersConfirmationInstructionsMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiUsersConfirmationInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersConfirmationInstructionsMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiUsersConfirmationInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersConfirmationInstructionsMutationRequestSchema },
    TContext
  >;
}

export const postApiUsersConfirmationMutationKey = () => [{ url: '/api/users/confirmation' }] as const;

export type PostApiUsersConfirmationMutationKey = ReturnType<typeof postApiUsersConfirmationMutationKey>;

export function postApiUsersConfirmationMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiUsersConfirmationMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiUsersConfirmationMutationKey();
  return mutationOptions<
    PostApiUsersConfirmationMutationResponseSchema,
    ResponseErrorConfig<PostApiUsersConfirmation400Schema | PostApiUsersConfirmation422Schema>,
    { data: PostApiUsersConfirmationMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiUsersConfirmation(data, config);
    },
  });
}

/**
 * @summary Confirms a user
 * {@link /api/users/confirmation}
 */
export function usePostApiUsersConfirmation<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiUsersConfirmationMutationResponseSchema,
      ResponseErrorConfig<PostApiUsersConfirmation400Schema | PostApiUsersConfirmation422Schema>,
      { data: PostApiUsersConfirmationMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiUsersConfirmationMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiUsersConfirmationMutationKey();

  const baseOptions = postApiUsersConfirmationMutationOptions(config) as UseMutationOptions<
    PostApiUsersConfirmationMutationResponseSchema,
    ResponseErrorConfig<PostApiUsersConfirmation400Schema | PostApiUsersConfirmation422Schema>,
    { data: PostApiUsersConfirmationMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiUsersConfirmationMutationResponseSchema,
    ResponseErrorConfig<PostApiUsersConfirmation400Schema | PostApiUsersConfirmation422Schema>,
    { data: PostApiUsersConfirmationMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiUsersConfirmationMutationResponseSchema,
    ResponseErrorConfig<PostApiUsersConfirmation400Schema | PostApiUsersConfirmation422Schema>,
    { data: PostApiUsersConfirmationMutationRequestSchema },
    TContext
  >;
}

export const postApiUsersMutationKey = () => [{ url: '/api/users' }] as const;

export type PostApiUsersMutationKey = ReturnType<typeof postApiUsersMutationKey>;

export function postApiUsersMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiUsersMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = postApiUsersMutationKey();
  return mutationOptions<
    PostApiUsersMutationResponseSchema,
    ResponseErrorConfig<PostApiUsers422Schema>,
    { data: PostApiUsersMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiUsers(data, config);
    },
  });
}

/**
 * @summary Creates a user
 * {@link /api/users}
 */
export function usePostApiUsers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiUsersMutationResponseSchema,
      ResponseErrorConfig<PostApiUsers422Schema>,
      { data: PostApiUsersMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiUsersMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiUsersMutationKey();

  const baseOptions = postApiUsersMutationOptions(config) as UseMutationOptions<
    PostApiUsersMutationResponseSchema,
    ResponseErrorConfig<PostApiUsers422Schema>,
    { data: PostApiUsersMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiUsersMutationResponseSchema,
    ResponseErrorConfig<PostApiUsers422Schema>,
    { data: PostApiUsersMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiUsersMutationResponseSchema,
    ResponseErrorConfig<PostApiUsers422Schema>,
    { data: PostApiUsersMutationRequestSchema },
    TContext
  >;
}

export const patchApiUsersMeMutationKey = () => [{ url: '/api/users/me' }] as const;

export type PatchApiUsersMeMutationKey = ReturnType<typeof patchApiUsersMeMutationKey>;

export function patchApiUsersMeMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiUsersMeMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = patchApiUsersMeMutationKey();
  return mutationOptions<
    PatchApiUsersMeMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersMe401Schema | PatchApiUsersMe422Schema>,
    { data: PatchApiUsersMeMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return patchApiUsersMe(data, config);
    },
  });
}

/**
 * @summary Updates current user
 * {@link /api/users/me}
 */
export function usePatchApiUsersMe<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiUsersMeMutationResponseSchema,
      ResponseErrorConfig<PatchApiUsersMe401Schema | PatchApiUsersMe422Schema>,
      { data: PatchApiUsersMeMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiUsersMeMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchApiUsersMeMutationKey();

  const baseOptions = patchApiUsersMeMutationOptions(config) as UseMutationOptions<
    PatchApiUsersMeMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersMe401Schema | PatchApiUsersMe422Schema>,
    { data: PatchApiUsersMeMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PatchApiUsersMeMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersMe401Schema | PatchApiUsersMe422Schema>,
    { data: PatchApiUsersMeMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PatchApiUsersMeMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersMe401Schema | PatchApiUsersMe422Schema>,
    { data: PatchApiUsersMeMutationRequestSchema },
    TContext
  >;
}

export const postApiUsersPasswordInstructionsMutationKey = () => [{ url: '/api/users/password/instructions' }] as const;

export type PostApiUsersPasswordInstructionsMutationKey = ReturnType<
  typeof postApiUsersPasswordInstructionsMutationKey
>;

export function postApiUsersPasswordInstructionsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiUsersPasswordInstructionsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiUsersPasswordInstructionsMutationKey();
  return mutationOptions<
    PostApiUsersPasswordInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersPasswordInstructionsMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiUsersPasswordInstructions(data, config);
    },
  });
}

/**
 * @summary Sends password reset instructions
 * {@link /api/users/password/instructions}
 */
export function usePostApiUsersPasswordInstructions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiUsersPasswordInstructionsMutationResponseSchema,
      ResponseErrorConfig<Error>,
      { data: PostApiUsersPasswordInstructionsMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiUsersPasswordInstructionsMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiUsersPasswordInstructionsMutationKey();

  const baseOptions = postApiUsersPasswordInstructionsMutationOptions(config) as UseMutationOptions<
    PostApiUsersPasswordInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersPasswordInstructionsMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiUsersPasswordInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersPasswordInstructionsMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiUsersPasswordInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersPasswordInstructionsMutationRequestSchema },
    TContext
  >;
}

export const patchApiUsersPasswordMutationKey = () => [{ url: '/api/users/password' }] as const;

export type PatchApiUsersPasswordMutationKey = ReturnType<typeof patchApiUsersPasswordMutationKey>;

export function patchApiUsersPasswordMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiUsersPasswordMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const mutationKey = patchApiUsersPasswordMutationKey();
  return mutationOptions<
    PatchApiUsersPasswordMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersPassword400Schema | PatchApiUsersPassword422Schema>,
    { data: PatchApiUsersPasswordMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return patchApiUsersPassword(data, config);
    },
  });
}

/**
 * @summary Updates password with reset token
 * {@link /api/users/password}
 */
export function usePatchApiUsersPassword<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiUsersPasswordMutationResponseSchema,
      ResponseErrorConfig<PatchApiUsersPassword400Schema | PatchApiUsersPassword422Schema>,
      { data: PatchApiUsersPasswordMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiUsersPasswordMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchApiUsersPasswordMutationKey();

  const baseOptions = patchApiUsersPasswordMutationOptions(config) as UseMutationOptions<
    PatchApiUsersPasswordMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersPassword400Schema | PatchApiUsersPassword422Schema>,
    { data: PatchApiUsersPasswordMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PatchApiUsersPasswordMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersPassword400Schema | PatchApiUsersPassword422Schema>,
    { data: PatchApiUsersPasswordMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PatchApiUsersPasswordMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersPassword400Schema | PatchApiUsersPassword422Schema>,
    { data: PatchApiUsersPasswordMutationRequestSchema },
    TContext
  >;
}

export const postApiUsersUnlockInstructionsMutationKey = () => [{ url: '/api/users/unlock/instructions' }] as const;

export type PostApiUsersUnlockInstructionsMutationKey = ReturnType<typeof postApiUsersUnlockInstructionsMutationKey>;

export function postApiUsersUnlockInstructionsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiUsersUnlockInstructionsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const mutationKey = postApiUsersUnlockInstructionsMutationKey();
  return mutationOptions<
    PostApiUsersUnlockInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersUnlockInstructionsMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiUsersUnlockInstructions(data, config);
    },
  });
}

/**
 * @summary Sends an unlock instructions email
 * {@link /api/users/unlock/instructions}
 */
export function usePostApiUsersUnlockInstructions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiUsersUnlockInstructionsMutationResponseSchema,
      ResponseErrorConfig<Error>,
      { data: PostApiUsersUnlockInstructionsMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiUsersUnlockInstructionsMutationRequestSchema>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiUsersUnlockInstructionsMutationKey();

  const baseOptions = postApiUsersUnlockInstructionsMutationOptions(config) as UseMutationOptions<
    PostApiUsersUnlockInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersUnlockInstructionsMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiUsersUnlockInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersUnlockInstructionsMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostApiUsersUnlockInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    { data: PostApiUsersUnlockInstructionsMutationRequestSchema },
    TContext
  >;
}
